import { useCappsLandlordApplicationDataWebApiHandler_getArchivedApplications } from '@zg-rentals/ts-capps-client-react-query';

export function useGetArchivedApplications(listingAlias: string) {
  // staleTime is 0 because when the user navigates back to this page after viewing, approving or denying an application
  // The list will update accordingly
  return useCappsLandlordApplicationDataWebApiHandler_getArchivedApplications({ listingAlias }, { staleTime: 0 });
}
